export default "__VITE_ASSET__DBajEUJG__"